export default (api) => ({
    list: (params) => api.get('/user-management', { params }),
    create: (params) => api.post('/user-management', params),
    cancel: ({ userInvitationUid }) => api.post(`/user-management/${userInvitationUid}/cancel`),
    revoke: ({ userInvitationUid }) => api.post(`/user-management/${userInvitationUid}/revoke`),
})
